export default function (http) {
    return {
        handleStatus(params){
            return http.json({
                url: `/home/setting/handleStatus`,
                params
            });
        },

        /**
         * 查询列表
         * @param data
         * @return {*}
         */
         queryByPage(data) {
            return http.json({
                url: '/home/setting/query',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/home/setting/get?id=${data.id}`
            })
        },


        /**
         * 保存
         * @param data
         * @return {*}
         */
         saveInfo(data) {
            return http.json({
                url: '/home/setting/save',
                data
            })
        },

        /**
         * 删除
         * @param data
         * @return {*}
         */
        delete(data) {
            return http.json({
                url: `/home/setting/delete?id=`+ data.id,
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/home.js